import React, { Fragment } from 'react';
import { connect } from 'react-redux';


const CoverLogo = ({ project }) => {
  const logo = project.templateOptions.headerLogo;
  if (!logo) {
    return null;
  }

  return (
    <Fragment>
      <img
        src={logo}
        alt=""
        style={{
          width: '250px',
          maxWidth: '100%',
          display: 'block',
          margin: '0 auto',
          filter: 'drop-shadow(0 0 5px rgba(0,0,0,.5))',
        }}
      />
      <div style={{
        height: 4,
        background: '#fff',
        width: 250,
        margin: '25px auto 30px',
        boxShadow: '0 0 10px rgba(0,0,0,.5)',
      }} />
    </Fragment>
  );
};

export default connect(({ project }) => ({ project }))(CoverLogo);



// WEBPACK FOOTER //
// ./src/components/Covers/CoverLogo.js